$(function(){
	$('.carousel').carousel();

    if($("#oddsBoostCarousel").length > 0) {
        var obCarousel = document.querySelector('#oddsBoostCarousel')
        var carousel = new bootstrap.Carousel(obCarousel)

        var totalItems = $('.carousel-item').length;
        var currentIndex = $('div.active').index() + 1;

        $('.odds-carousel-num').html('' + currentIndex + ' / ' + totalItems + '');
        $('#oddsBoostCarousel').bind('slid.bs.carousel', function () {
            currentIndex = $('div.active').index() + 1;
            $('.odds-carousel-num').html('' + currentIndex + ' / ' + totalItems + '');
        });
    }

// Auto refresh live-game section if it exists
    refresh_live_new();
    setInterval(refresh_live_new, 60000);
    setInterval(refresh_live_match, 15000);
    setInterval(refresh_live_list_match, 30000);

    $(window).on('focus', function () {
        refresh_live_match();
        refresh_live_new();
        refresh_live_list_match();
    });

    if($(".table-match-odds").length > 0){
        highlightOddsTable();
    }

    /*const queryString = window.location.search;
    const urlParams = new URLSearchParams(queryString);
    console.log(urlParams.get('speltips'));*/

    /*$('[data-spy="scroll"]').each(function() {
        var $spy = $(this).scrollspy('refresh');
    });*/
    /*$(".test-anch-link").click(function(e) {
        e.preventDefault();
        //if (location.pathname.replace(/^\//,'') == this.pathname.replace(/^\//,'') && location.hostname == this.hostname) {
            var target = $(this.hash);
            target = target.length ? target : $('[id=' + this.hash.slice(1) +']');
            if (target.length) {
                $('html,body').animate({
                    scrollTop: target.offset().top-150
                }, 1000);
                return false;

            }
        //}
    });*/

	/*$('#match_menu').on('activate.bs.scrollspy', function(){
	    console.log("mm");
		var activeTab = $('.nav-tabs li.active a');
		activeTab.parent().removeClass('active');
		activeTab.tab('show');
	});*/

    $(".bg-panel-link").click(function(){
        var el = $(this).find("i");
        if(el.hasClass("fa-caret-right")){
            el.removeClass("fa-caret-right").addClass("fa-caret-down");
        } else {
            el.removeClass("fa-caret-down").addClass("fa-caret-right");
        }
    });

    $(document).on('click', '#match_menu .nav-link', function(e){
        e.preventDefault();
        console.log('klick');
        if($(this).prop('hash') != "#refresh") {
            document.querySelector($(this).prop('hash')).scrollIntoView({
                behavior: 'smooth'
            });
            location.hash = '';
        }
        return false;
    });

    if($(".lineup_home > .forward").length == 2){
        var forwards = ["l6_2", "l6_4"];
        $(".lineup_home > .forward").each(function(i){
            var f_class = forwards.shift();
            $(this).removeClass();
            $(this).addClass("player");
            $(this).addClass("forward");
            $(this).addClass(f_class);
        });
    }

    if($(".lineup_away > .forward").length == 2){
        var forwards = ["l6_2", "l6_4"];
        $(".lineup_away > .forward").each(function(i){
            var f_class = forwards.shift();
            $(this).removeClass();
            $(this).addClass("player");
            $(this).addClass("forward");
            $(this).addClass(f_class);
        });
    }

    $(document).on("click", ".odds-tabs > ul > li > a", function(){
	    $('.odds-tabs > ul > li').removeClass('active');
	    $(this).parent().addClass('active');
        var odds_type = $(this).data("odds-type");

        if(odds_type == "over_under" || odds_type == "asian" || odds_type == "ht_ft" || odds_type == "corners_over_under"){
            var fillDropdown = 1;
            if(odds_type == "asian" || odds_type == "ht_ft" || odds_type == "corners_over_under" || odds_type == "over_under" ){
                if(odds_type == "ht_ft" || odds_type == "over_under" || odds_type == "corners_over_under"){
                    $("#1st").remove();
                }
                $("#2nd").remove();
            } else {
                if(!$("#1st").length){
                    $('<li id="1st"><a class="nav-link" href="#first" data-half="first" data-odds-type="" data-toggle="tab">1:a</a></li>').insertAfter($("#FT"));
                }
                $("#1st").show();
                if(!$("#2nd").length) {
                    $('<li id="2nd"><a class="nav-link" href="#second" data-half="second" data-odds-type="" data-toggle="tab">2:a</a></li>').insertAfter($("#1st"));
                }
                //$("#2nd").show();
            }
        } else {
            var fillDropdown = 0;
            if(odds_type == "double" || odds_type == "odd_even") {
                $("#1st").remove();
                $("#2nd").remove();
            } else {
                if(!$("#1st").length){
                    $('<li id="1st"><a class="nav-link" href="#first" data-half="first" data-odds-type="" data-toggle="tab">1:a</a></li>').insertAfter($("#FT"));
                }
                if(!$("#2nd").length) {
                    $('<li id="2nd"><a class="nav-link" href="#second" data-half="second" data-odds-type="" data-toggle="tab">2:a</a></li>').insertAfter($("#1st"));
                }
            }
            //$(".odds-pills > .nav-dropdown").hide();
            $("#odds-sub-select").remove();
        }

        if($("#show-odds-type").is(":visible")){
            $("#show-odds-type").text($(this).data("title"));
        }

        $(".odds-sub-tabs > ul > li > a").each(function(){
            $(this).data("odds-type", odds_type);
        });

        $(".odds-sub-tabs > ul > li").not($("#FT")).removeClass("active");

        $("#FT").addClass("active");
        $("#half").val("fulltime");


        var match_id  = $("#mid").val();

        if(fillDropdown){
            $.get(
                ajaxUrl+"/ajax/getOddsDropdown.php",
                {
                    match_id : match_id,
                    type : odds_type
                },
                function(data){
                    var result = $.parseJSON(data);
                    if(result.success == true){
                        if(!$("#odds-sub-select").length){
                            $(".odds-sub-tabs > ul ").append('<li id="odds-sub-select"><select data-odds-type="over_under" id="odds-select" data-half="fulltime"></select></li>');
                        }
                        $(".odds-sub-tabs > ul > li > select").html(result.data);
                        $(".odds-sub-tabs > ul > li > select").data("odds-type", odds_type);
                        $(".odds-sub-tabs > ul > li > select").show();
                        $(".odds-sub-tabs > ul > li > select").select2({
							minimumResultsForSearch: -1
                        });
                    }
                }
            )
        }

        $.get(
            ajaxUrl+"/ajax/getOdds.php",
            {
                type : odds_type,
                match_id : match_id
            },
            function(data){
                var result = $.parseJSON(data);
                if(result.success == true){
                    $("#odds_content").html(result.data);
                    highlightOddsTable();
                } else {
                    $("#odds_content").html("<p class='text-center noodds'>Inga odds hittades..</p>");
                }
            }
        );

    });

    $(document).on("click", ".odds-sub-tabs > ul > li > a", function(e){
        var odds_type = $(this).data("odds-type");
        var half = $(this).data("half");
        $("#half").val(half);
        var match_id = $("#mid").val();

        if(odds_type == "asian" || odds_type == "over_under" || odds_type == "corners_over_under"){
            if(odds_type == "asian"){
                var handicap = 1;
            } else {
                var handicap = 0;
            }
            var label = $(".odds-sub-tabs > ul > li > select").val();
        } else if(odds_type == "ht_ft"){
            var handicap = 0;
            var label = "1/1"
        } else {
            var handicap = 0;
            var label = 0;
        }

        $(".odds-pills > .nav-dropdown > select").data("half", half);
        console.log('here1');
        $.get(
            ajaxUrl+"/ajax/getOdds.php",
            {
                type : odds_type,
                half : half,
                match_id : match_id,
                label : label,
                handicap : handicap
            },
            function(data){
                var result = $.parseJSON(data);
                if(result.success == true){
                    $("#odds_content").html(result.data);
                    highlightOddsTable();
                } else {
                    $("#odds_content").html("<p class='text-center noodds'>Inga odds hittades..</p>");
                }
            }
        );
    });

    $(document).on("change", ".odds-sub-tabs > ul > li > select", function(e){

        var label = $(this).val();

        if(label == "X/X"){
            label = "draw_draw";
        }
        if(label == "X/1"){
            label = "draw_home";
        }
        if(label == "X/2"){
            label = "draw_away";
        }
        var odds_type = $(this).data("odds-type");
        if(odds_type == "over_under" || odds_type == "ht_ft" || odds_type == "corners_over_under"){
            var handicap = 0;
        } else {
            var handicap = 1;
        }

        var half = $("#half").val();
        var match_id = $("#mid").val();
        console.log('here2');
        $.get(
            ajaxUrl+"/ajax/getOdds.php",
            {
                type : odds_type,
                half : half,
                match_id : match_id,
                label : label,
                handicap : handicap
            },
            function(data){
                var result = $.parseJSON(data);
                if(result.success == true){
                    $("#odds_content").html(result.data);
                    highlightOddsTable();
                } else {
                    $("#odds_content").html("<p class='text-center noodds'>Inga odds hittades..</p>");
                }
            }
        );
    });

    $(document).on("change", ".odds-page-sub-tabs > ul > li > select", function(e){
        var label = $(this).val();
        var type = $("#odds-page-type").val();
        $(".odds-fixture-placeholder").each(function(i){
            var parent = $(this);
            var match_id = $(this).data("match-id");
            $.get(
                ajaxUrl+"/ajax/getOddsPerMatch.php",
                {
                    match_id : match_id,
                    type : type,
                    label : label
                },
                function(data){
                    var result = $.parseJSON(data);
                    if(result.success == true){
                        console.log(result.data);
                        Object.keys(result.data).forEach(key => {
                            parent.find(`[data-odds='${key}']`).text(result.data[key]);
                        });
                    }
                }
            )
        });
    });


    if($("#live_clock").length){

        var kickoff_time = $("#live_kickoff_time").val();

        $('#live_clock').countdown(kickoff_time, function(event) {
            $(this).html(event.strftime('%H:%M:%S'));
        });
    }

    $(".btn-prediction").click(function(){
        if($(".predicted").length){
            return false;
        }
        $(this).addClass("predicted");
        var match_id = $(this).data("match-id");
        var prediction = $(this).data("prediction");

        $.post(
            ajaxUrl+"/ajax/setPrediction.php",
            {
                match_id : match_id,
                prediction : prediction
            },
            function(data){
                var result = $.parseJSON(data);
                if(result.success == true){
                    Cookies.set(match_id, prediction, { expires: 7, path: '/match' });
                    $("#predictions > .row").css("margin-bottom", "15px");
                    $("#predictions").append(result.data).fadeIn();
                }
            }
        );
        return false;
    });

    if($("#extended_stats_chart").length){
        var extended_stats_chart = $("#extended_stats_chart");
        var homePieChart = new Chart(extended_stats_chart,{
            type: 'line',
            data: {
                labels: [
                    '0-15',
                    '15-30',
                    '30-45',
                    '45-60',
                    '60-75',
                    '75-90'
                ],
                datasets: [{
                    label: $("#hometeam_scoring_minutes").data('team-name'),
                    data: [
                        $("#hometeam_scoring_minutes").data('first'),
                        $("#hometeam_scoring_minutes").data('second'),
                        $("#hometeam_scoring_minutes").data('third'),
                        $("#hometeam_scoring_minutes").data('fourth'),
                        $("#hometeam_scoring_minutes").data('fifth'),
                        $("#hometeam_scoring_minutes").data('sixth')
                    ],
                    borderColor: "#40E0D0",
                    lineTension : 0,
                    spanGaps : 1
                }, {
                    label: $("#awayteam_scoring_minutes").data('team-name'),
                    data: [
                        $("#awayteam_scoring_minutes").data('first'),
                        $("#awayteam_scoring_minutes").data('second'),
                        $("#awayteam_scoring_minutes").data('third'),
                        $("#awayteam_scoring_minutes").data('fourth'),
                        $("#awayteam_scoring_minutes").data('fifth'),
                        $("#awayteam_scoring_minutes").data('sixth')
                    ],
                    borderColor: "#2194cf",
                    lineTension : 0
                }]
            },
            options: {
                legend: {
                    labels: {
                        // This more specific font property overrides the global property
                        fontColor: '#000'
                    }
                },
            }
        });
    }
    if($("#predictions_chart").length){
        var predictionsChart = new Chart(document.getElementById("predictions_chart"), {
            type: 'bar',
            data: {
                labels: ["1", "X", "2"],
                datasets: [
                    {
                        label: "Antal röster",
                        backgroundColor: ["#395e8b", "#fff","#ffa500"],
                        data: [
                            $("#match_predictions").data('home'),
                            $("#match_predictions").data('draw'),
                            $("#match_predictions").data('away')
                        ]
                    }
                ]
            },
            options: {
                legend: { display: false },
                scales: {
                    yAxes: [{
                        ticks: {
                            beginAtZero: true
                        }
                    }]
                }
            }
        });

    }

    if($("#matchstats").length > 0){
        var twoColComp = {
            init: function (){
                var tables = $('#matchstats');
                this.make(tables[0]);
            },

            make : function(el){
                var rows = el.getElementsByTagName('tr'),
                    vals = [],
                    max,
                    percent;

                for(var x = 0; x < rows.length; x++) {
                    var cells = rows[x].getElementsByClassName('td-compare');
                    for(var y = 1; y < cells.length; y++){
                        vals.push(parseInt(cells[y].innerHTML, 10));
                    }
                }

                max = Math.max.apply( Math, vals );
                percent = 100/max;

                for(x = 0; x < rows.length; x++) {
                    var cells = rows[x].getElementsByClassName('td-compare');
                    for(var y = 0; y < cells.length; y++){
                        var currNum = parseInt(cells[y].getAttribute('data-percentage'), 10);
                        cells[y].style.backgroundSize = currNum + "% 100%";
                        cells[y].style.transitionDelay = x/20 + "s";
                    }
                }

                el.className =+ " two-column-comp"
            }
        }
        twoColComp.init();
    }

    /*$(document).on("click", ".match_menu > li > a", function () {
	    $('.match_menu > li').removeClass('active');
        $(this).parent().addClass('active');
        
    });*/

    $(document).on("click", ".do-refresh-live", function(){
        var el = $(this).children(':first-child');
        el.addClass('fa-spin');
        setTimeout(() => {
            $('.do-refresh-live').children(':first-child').removeClass('fa-spin');
        }, "1900")
        refresh_live_match();
        setInterval(refresh_live_match, 15000);
        return false;
    });

});

function refresh_live_new() {
// Only proceed if we have games playing.
    if($(".live_fixtures").length){
        $.get(
            ajaxUrl+"/ajax/getLivescore.php",
            function(data){
                var result = $.parseJSON(data);
                if(result.success == true){
                    $(".live_fixtures").html(result.fixtures);
                    checkNotificationCheckboxes();
                    $('img[data-src]').each(function(img){
                        $(this).attr('src', $(this).data('src'));
                        $(this).removeAttr('data-src');
                    });
                }
            }
        );
    }
}

function refresh_live_match() {
// Only proceed if we have games playing.
    if($("#live_match").val() == 1){
        $(".live-match-spinner").fadeIn("fast");
        $(".live-match-spinner").delay(5000).fadeOut();
        $.get(
            ajaxUrl+"/ajax/getLiveMatch.php",
            {
                match_id : $("#match_id").val()
            },
            function(data){
                var result = $.parseJSON(data);
                if(result.success == true){
                    $(".match_result_ns").replaceWith(result.resultSection);
                    $(".match_result").replaceWith(result.resultSection);
                    $(".match_events").html(result.events);
                    $(".match_statistics").html(result.statistics);

                    if($("#matchstats").length > 0){
                        var twoColComp = {
                            init: function (){
                                var tables = $('#matchstats');
                                this.make(tables[0]);
                            },

                            make : function(el){
                                var rows = el.getElementsByTagName('tr'),
                                    vals = [],
                                    max,
                                    percent;

                                for(var x = 0; x < rows.length; x++) {
                                    var cells = rows[x].getElementsByClassName('td-compare');
                                    for(var y = 1; y < cells.length; y++){
                                        vals.push(parseInt(cells[y].innerHTML, 10));
                                    }
                                }

                                max = Math.max.apply( Math, vals );
                                percent = 100/max;

                                for(x = 0; x < rows.length; x++) {
                                    var cells = rows[x].getElementsByClassName('td-compare');
                                    for(var y = 0; y < cells.length; y++){
                                        var currNum = parseInt(cells[y].getAttribute('data-percentage'), 10);
                                        cells[y].style.backgroundSize = currNum + "% 100%";
                                        cells[y].style.transitionDelay = x/20 + "s";
                                    }
                                }

                                el.className =+ " two-column-comp"
                            }
                        }
                        twoColComp.init();
                    }

                }
            }
        );
    }
}

function refresh_live_list_match() {
// Only proceed if we have games playing.
	if($(".list-fixture-live").length > 0){
		$(".list-fixture-live").each(function(){
		   var match_id = $(this).data("live-id");
		   var el = $(this);
			$.get(
                ajaxUrl+"/ajax/getLiveListMatch.php",
                {
                    match_id : match_id
                },
                function(data){
                    var result = $.parseJSON(data);
                    if(result.success == true){
                        el.replaceWith(result.html);
                    }
                }
			);
        });

	}
}
function highlightOddsTable(){
    var i = 1;

    while (i < $('tr:first-child td').length) {
        var ar = $('.table-match-odds tr').map(function () {
            return Number($(this).find('td:nth-child(' + (i + 1) + ')').text());
        })

        var max = Math.max.apply(null, ar);

        var ar = $('.table-match-odds tr').find('td').each(function () {
            if (Number($(this).text()) == max) {
                $(this).addClass('best_odds');
            }
        });

        i++;
    }
}
function highlightAvgOddsTable(){
	/*var i = 1;

	while (i < $('tr:first-child td').length) {
		var ar = $('#avg-odds tr').map(function () {
		    if($(this).find('td:nth-child(' + (i + 1) + ')').text() != "") {
				return Number($(this).find('td:nth-child(' + (i + 1) + ')').text());
			}
		})
        console.log(ar);

		var max = Math.max.apply(null, ar);
		console.log(max);

		var ar = $('#avg-odds tr').find('td').each(function () {
			if (Number($(this).text()) == max) {
				$(this).addClass('best_odds');
			}
		});

		i++;
	}*/
	var cols = []
	var trs = $('#avg-odds tr')
	var data =$.each(trs , function(index, tr){
		$.each($(tr).find("td").not(":first"), function(index, td){
			cols[index] = cols[index] || [];
			cols[index].push($(td).text())
		})
	});
	cols.forEach(function(col, index){
		var max = Math.max.apply(null, col);
		var min = Math.min.apply(null, col)
		$('#avg-odds tr').find('td:eq('+(index+1)+')').each(function(i, td){
			$(td).toggleClass('best_odds', +$(td).text() === max)
			//$(td).toggleClass('min', +$(td).text() === min)
		})
	})
}